import { useEffect, useState } from 'react';

const navItems = [
  { id: 'hot', label: '热播剧' },
  { id: 'tv', label: '电视剧' },
  { id: 'movie', label: '电影' },
  { id: 'collection', label: '全集' },
  { id: 'source', label: '片源' },
  { id: 'rank', label: '榜单' },
  { id: 'genre', label: '类型' },
  { id: 'faq', label: '问答' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 240);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 border-b border-background-200 backdrop-blur' : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-8 h-16">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-500 text-background-50">
            <i className="ri-cup-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-base font-bold text-foreground-950">茶杯狐影视</span>
            <span className="text-[10px] tracking-widest text-foreground-500">CHABEIHU MEDIA</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="px-3 py-2 text-sm text-foreground-700 rounded-md cursor-pointer transition-colors hover:text-primary-700 hover:bg-primary-100"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#hot"
            className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium whitespace-nowrap rounded-md bg-primary-500 text-background-50 cursor-pointer transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-circle-line"></i>
            开始浏览
          </a>
          <button
            type="button"
            aria-label="展开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden flex items-center justify-center w-10 h-10 rounded-md border border-background-200 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-800 rounded-md bg-background-100 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}